import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from 'antd';

const ButtonGroup = Button.Group;

const TransferBar = ({ commands, onAddClick, onRemoveClick }) => (
  <div className="bhp-transfer-commands">
    <ButtonGroup>
      {(
        <Tooltip title="Add Item" placement="bottom">
          <Button icon="down" disabled={commands.disableAdd} onClick={onAddClick}>
            Add
          </Button>
        </Tooltip>
      )}
      {(
        <Tooltip title="Remove Item" placement="bottom">
          <Button icon="up" disabled={commands.disableRemove} onClick={onRemoveClick}>
            Remove
          </Button>
        </Tooltip>
      )}
    </ButtonGroup>
  </div>
);

TransferBar.propTypes = {
  commands: PropTypes.object,
  onAddClick: PropTypes.func,
  onRemoveClick: PropTypes.func
};

TransferBar.defaultProps = {
  commands: {},
  onAddClick() {
  },
  onRemoveClick() {
  }
};

export default TransferBar;
